import { render, staticRenderFns } from "./InscBookings.vue?vue&type=template&id=0bf0b5fa&"
import script from "./InscBookings.vue?vue&type=script&lang=js&"
export * from "./InscBookings.vue?vue&type=script&lang=js&"
import style0 from "./InscBookings.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports